import React from 'react';
import Style from 'styles/components/cmp.module.scss';

const Comparison = () => (
  <section className={Style.cmp}>
    <h2 className={Style.cmp__title}>他社のサービスとの比較</h2>
    <div className={Style.cmp__subTitle}>
      当社の独自調査による比較となります（2025年5月19日時点）。
    </div>

    <div className={Style.cmp__pricingTable}>
      <table>
        <thead>
          <tr>
            <th colSpan={2}></th>
            <th className={Style.cmp__highlightHeader}>
              comachicart<br />スタンダードプラン
            </th>
            <th>他社サービス<br />A</th>
            <th>他社サービス<br />B</th>
            <th>他社サービス<br />C</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th rowSpan={3}>カートシステム</th>
            <td>初期費用</td>
            <td className={Style.cmp__highlight}>0円</td>
            <td>0円</td>
            <td>3,300円</td>
            <td>0円</td>
          </tr>
          <tr>
            <td>月額費用</td>
            <td className={Style.cmp__highlight}>0円</td>
            <td>0円</td>
            <td>4,950円</td>
            <td>4,850円</td>
          </tr>
          <tr>
            <td>システム利用料</td>
            <td className={Style.cmp__highlight}>3%</td>
            <td>3%</td>
            <td>0円</td>
            <td>2%<sup>*5</sup></td>
          </tr>
          <tr>
            <th rowSpan={3}>クレジットカード</th>
            <td>月額費用</td>
            <td className={Style.cmp__highlight}>0円</td>
            <td>0円</td>
            <td>40円</td>
            <td>0円</td>
          </tr>
          <tr>
            <td>
              <div>売上処理量</div>
              <div className={Style.cmp__pricingTable__note}>
                (トランザクション費用)
              </div>
            </td>
            <td  className={Style.cmp__highlight}>0円</td>
            <td>0円</td>
            <td>0円</td>
            <td>0円</td>
          </tr>
          <tr>
            <td>決済手数料</td>
            <td className={Style.cmp__highlight}>3.5%</td>
            <td>3.6%</td>
            <td>3.4%</td>
            <td>3.55%、3.9%<sup>*6</sup></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className={Style.notice}>
      <div>*5 C社が提供する決済サービスを利用していない場合となります。</div>
      <div>*6 利用されるクレジットカード会社によって手数料が異なります。</div>
    </div>
  </section>
);

export default Comparison;
